const mediaData = [
  {
    title: '《长安十二时辰》精彩片段：雷佳音硬核打戏集锦',
    duration: '08:24',
    views: '128.6万',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20action%20drama%20scene%20with%20warriors%20in%20traditional%20armor%2C%20dramatic%20cinematic%20lighting%2C%20epic%20battle%20atmosphere%2C%20warm%20amber%20and%20gold%20tones%2C%20professional%20film%20production%20quality%2C%20dark%20moody%20background&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    title: '《流浪地球2》幕后花絮：吴京刘德华对戏全记录',
    duration: '12:56',
    views: '95.3万',
    img: 'https://readdy.ai/api/search-image?query=Sci-fi%20film%20behind%20the%20scenes%20with%20futuristic%20spacesuit%20and%20advanced%20technology%20set%2C%20dramatic%20studio%20lighting%2C%20professional%20film%20production%20aesthetic%2C%20warm%20accent%20lights%2C%20dark%20atmospheric%20background&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    title: '《庆余年第二季》范闲朝堂舌战名场面',
    duration: '06:48',
    views: '156.2万',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20court%20scene%20with%20elaborate%20traditional%20costumes%2C%20imperial%20palace%20setting%2C%20dramatic%20lighting%20from%20lanterns%2C%20warm%20golden%20atmosphere%2C%20cinematic%20composition%2C%20epic%20period%20drama%20aesthetic&width=640&height=360&seq=media-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50 mb-3">精彩视频</h2>
          <p className="text-foreground-400 text-sm">精选热门影视片段与幕后花絮，精彩不容错过</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-[1100px] mx-auto">
          {mediaData.map((item, i) => (
            <div key={i} className="group cursor-pointer rounded-xl overflow-hidden bg-background-100 border border-background-300/40 hover:border-accent-500/30 transition-all duration-300">
              <div className="relative overflow-hidden aspect-video">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" width="640" height="360" />
                <div className="absolute inset-0 bg-background-950/30 group-hover:bg-background-950/20 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-950/60 flex items-center justify-center border-2 border-foreground-50/60 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-2xl text-foreground-50 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-foreground-200 text-xs whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-bold text-foreground-50 text-sm group-hover:text-accent-400 transition-colors leading-snug mb-2">{item.title}</h3>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}